import React from "react";
import { usePageMeta } from "@/lib/usePageMeta";
import LegalLayout from "@/components/LegalLayout";
import { useCookieCtx } from "@/components/CookieBanner";

export default function CookiesPage() {
  const ctx = useCookieCtx();
  usePageMeta({
    title: "Cookies | STK Komfort Znojmo",
    description:
      "Zásady cookies na webu STK Komfort Znojmo. Které soubory cookies používáme a jak můžete spravovat svůj souhlas.",
    canonical: "https://www.stkkomfort.cz/cookies",
  });

  return (
    <LegalLayout
      title="Zásady používání cookies"
      lead="Tyto zásady vysvětlují, jak web STK Komfort™ používá cookies a podobné technologie, jaké kategorie cookies existují a jak můžete kdykoliv změnit své nastavení."
    >
      <h2>1. Co jsou cookies</h2>
      <p>
        Cookies jsou malé textové soubory, které se ukládají ve vašem zařízení při návštěvě
        webu. Některé cookies jsou nezbytné pro správné fungování webu, jiné nám pomáhají
        zlepšovat služby, měřit návštěvnost nebo vyhodnocovat reklamu.
      </p>

      <h2>2. Jaké cookies používáme</h2>
      <p>Web STK Komfort™ rozlišuje tři kategorie cookies:</p>

      <h3>Technické cookies</h3>
      <p>
        Jsou nezbytné pro funkci webu — zajišťují bezpečné odeslání formuláře, uložení
        nastavení cookies, technickou stabilitu a základní fungování. Tyto cookies používáme
        na základě oprávněného zájmu a nelze je vypnout.
      </p>

      <h3>Analytické cookies</h3>
      <p>
        Pomáhají nám porozumět návštěvnosti webu, měřit kliknutí na telefon, formulář a další
        důležité prvky. Používáme je <strong>výhradně se souhlasem uživatele</strong>.
        Bez souhlasu se neaktivují.
      </p>

      <h3>Marketingové cookies</h3>
      <p>
        Pomáhají měřit účinnost reklamy a zobrazovat relevantnější nabídky. Používáme je
        <strong> výhradně se souhlasem uživatele</strong>. Bez souhlasu se neaktivují.
      </p>

      <h2>3. Jak změnit nastavení cookies</h2>
      <p>
        Nastavení můžete kdykoliv změnit kliknutím na tlačítko níže nebo přes odkaz
        &bdquo;Nastavení cookies&ldquo; v patičce webu.
      </p>
      <p>
        <button
          type="button"
          onClick={() => ctx && ctx.openSettings()}
          data-testid="open-cookie-settings"
          className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-b from-amber-300 to-amber-500 hover:from-amber-200 hover:to-amber-400 px-4 py-2.5 text-sm font-bold text-slate-900 transition-all !no-underline"
        >
          Nastavit cookies
        </button>
      </p>

      <h2>4. Jak dlouho cookies ukládáme</h2>
      <ul>
        <li>technické cookies — po dobu trvání relace nebo do 12 měsíců</li>
        <li>záznam o cookies souhlasu — až 12 měsíců</li>
        <li>analytické cookies — typicky 14–26 měsíců</li>
        <li>marketingové cookies — typicky 13–24 měsíců</li>
      </ul>

      <h2>5. Třetí strany</h2>
      <p>
        Pokud po vašem souhlasu spustíme nástroje třetích stran (např. Google Analytics 4,
        Meta Pixel), jejich cookies se mohou řídit také zásadami příslušného poskytovatele.
        <em> Pozn.: aktuální seznam aktivních nástrojů doplníme po spuštění tracking nastavení.</em>
      </p>

      <h2>6. Kontakt</h2>
      <p>
        V případě dotazů týkajících se cookies a soukromí se na nás obraťte přes kontaktní
        formulář, telefonicky na <a href="tel:+420775659129">+420 775 659 129</a>,
        nebo si přečtěte naše <a href="/ochrana-osobnich-udaju">Zásady ochrany osobních údajů</a>.
      </p>

      <p className="mt-10 text-xs text-slate-500">
        Tyto zásady jsou platné od data zveřejnění a mohou být průběžně aktualizovány.
      </p>
    </LegalLayout>
  );
}
